export default __webpack_public_path__ + "static/media/claim.eb22d757.png";